import { AutoFormSection } from "models/autoForm";
import { Task } from "features/Resources/Task/models";
import NewHireAutoSaveForm from "features/Form/Components/NewHireAutoSaveForm";
import NewHireInputForm from "../../NewHireInputForm";

interface FormSchema {
  sections: AutoFormSection[];
}

const INPUT_ONBOARDING_PLAN = {
  sections: [{
    fields: [
      {
        name: "onboardingPlanUrl",
        type: "text",
        label: "Onboarding Plan Url",
        accessor: "onboardingPlanUrl",
        writer: "newHireJourney.onboardingPlanUrl",
      },
    ],
  }],
} as FormSchema;

export function InputOnboardingPlanTaskActionForm({ task }: { task: Task }) {
  return <NewHireInputForm task={task} formSchema={INPUT_ONBOARDING_PLAN} />;
}

export function InputOnboardingPlanForm({ task, onSuccess }: { task: Task, onSuccess: (res: any) => void }) {
  return <NewHireAutoSaveForm formSchema={INPUT_ONBOARDING_PLAN} newHireId={task?.newHireJourneyId} onSuccess={onSuccess} />;
}
